module.exports = __webpack_public_path__ + "static/media/al.12987329.svg";